import React, { useState } from 'react';
import './GalleryImagesEditor.css';

interface GalleryImagesEditorProps {
  selectedSection: string | null;
  editMode: boolean;
  editableContent: { [key: string]: string };
  handleSectionClick: (section: string) => void;
  handleCarouselImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCarouselImageClick: (imageId: string) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
}

const GalleryImagesEditor: React.FC<GalleryImagesEditorProps> = ({
  selectedSection,
  editMode,
  editableContent,
  handleSectionClick,
  handleCarouselImageChange,
  handleCarouselImageClick,
  handleSaveChanges,
  handleCancelEdit,
}) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="gallery-editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => toggleSection('gallery')}>Imágenes Servicios</h3>
        {activeSection === 'gallery' && (
          <div className="accordion-content">
            {['pexels-thumb1', 'pexels-thumb2', 'pexels-thumb3', 'pexels-thumb4', 'pexels-thumb5'].map((thumb, index) => (
              <div key={thumb} className="gallery-item">
                <button
                  onClick={() => {
                    handleCarouselImageClick(thumb);
                    handleSectionClick(thumb);
                  }}
                  className={selectedSection === thumb ? 'selected-menu-item' : ''}
                >
                  Cambiar Imagen de Galería {index + 1}
                </button>
                {editMode && selectedSection === thumb && (
                  <div className="editor-panel">
                    <h4>Editar {thumb}</h4>
                    <input
                      type="file"
                      name={thumb}
                      onChange={handleCarouselImageChange}
                      accept="image/*"
                    />
                    <button onClick={handleSaveChanges}>Guardar Cambios</button>
                    <button onClick={handleCancelEdit}>Cancelar</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleryImagesEditor;
